/**
 * blog.jsx
 *
 * Page liste du blog (SEO + maillage interne).
 *
 * Pour le SEO :
 * - <h1> clair
 * - liens internes vers les articles (crawlable)
 * - meta title/description/canonical via useSEO
 */

import { Link } from "react-router-dom";
import { useSEO } from "../seo/useSEO";
import "./blog.css";

const POSTS = [
  {
    slug: "regle-50-30-20",
    title: "La règle 50/30/20 : structurer son budget simplement",
    excerpt:
      "Une méthode simple pour répartir tes revenus : besoins, envies, épargne/dettes. Avec un exemple chiffré.",
    date: "2026-01-13",
    readingTime: "5 min",
  },
];

export default function Blog() {
  useSEO({
    title: "Blog — Finance personnelle & budget | HowMuch",
    description:
      "Articles courts sur la finance personnelle : budget, épargne, objectifs. Découvre la règle 50/30/20 et des méthodes simples pour t’organiser.",
    canonicalPath: "/blog",
    ogType: "website",
  });

  return (
    <main className="bl">
      <header className="bl-header">
        <div className="bl-container bl-header-inner">
          <Link to="/" className="bl-brand" aria-label="Retour à l’accueil HowMuch">
            <div className="bl-logo">HM</div>
            <div>
              <div className="bl-brand-name">HowMuch</div>
              <div className="bl-brand-tag">Blog finance personnelle</div>
            </div>
          </Link>

          <nav className="bl-nav" aria-label="Navigation principale">
            <Link className="bl-link" to="/simulate">
              Simulateur
            </Link>
            <Link className="bl-link" to="/blog" aria-current="page">
              Blog
            </Link>
            <Link className="bl-link" to="/about">
              À propos
            </Link>
          </nav>
        </div>
      </header>

      <section className="bl-container bl-hero">
        <h1>Blog finance personnelle</h1>
        <p>
          Des articles pratiques pour mieux gérer ton budget, définir tes priorités, et avancer vers tes objectifs.
        </p>
      </section>

      <section className="bl-container bl-list" aria-label="Liste des articles">
        {POSTS.map((p) => (
          <article key={p.slug} className="bl-card">
            <div className="bl-card-meta">
              <time dateTime={p.date}>{new Date(p.date).toLocaleDateString("fr-FR")}</time>
              <span>•</span>
              <span>{p.readingTime}</span>
            </div>
            <h2 className="bl-card-title">
              <Link to={`/blog/${p.slug}`}>{p.title}</Link>
            </h2>
            <p className="bl-card-excerpt">{p.excerpt}</p>
            <Link className="bl-btn" to={`/blog/${p.slug}`}>
              Lire l’article →
            </Link>
          </article>
        ))}
      </section>

      <footer className="bl-footer">
        <div className="bl-container bl-footer-inner">
          <span>© {new Date().getFullYear()} HowMuch</span>
          <Link className="bl-link" to="/simulate">
            Faire une simulation
          </Link>
        </div>
      </footer>
    </main>
  );
}
